import React from 'react';

const AlertAccent = ({ children, title, text, showAlert }) => {
  return (
    <>
      {showAlert ? (
        <>
          <div className="px-4 py-3 leading-normal text-white bg-red-500 hover:bg-red-600 rounded-3xl cursor-pointer" role="alert">
            <p className="font-bold">{title}</p>
            <p>{text}</p>
            <div>{children}</div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default AlertAccent;
